import { SelectedSection } from '../types/courseSelectionTypes';

export enum SectionsErrors {
  CONFLICT_SECTION_SCHEDULE = 'CONFLICT_SECTION_SCHEDULE',
}

export const formatSectionError = (section: SelectedSection) => {
  return {
    code: section.name,
    horarios: section.sectionSchedules.map((sch) => {
      const day = sch.day || '';
      const start = sch.startModule?.startTime?.slice(0, 5) || '';
      const end = sch.endModule?.endTime?.slice(0, 5) || start;
      return `${day} ${start}-${end}`;
    }),
    salas: section.sectionSchedules.map((sch) => sch.classroom?.name || ''),
    profesores: section.professors.map((t) => t.account?.fullName || '') || [],
  };
};
